<template>
  <div class="box">
    <div class="title">区域代理商/服务商招募中</div>
    <div class="text">成立区域运营服务中心，做食安数字化事业合伙人</div>
    <div class="bottomItem">
      <div class="leftItem"></div>
      <div class="rightItem">
        <div class="itemBox" v-for="(item, index) in infoData" :key="index">
          <div class="header">
            <img class="img" :src="item.icon" alt="" />
            <div class="text">{{ item.title }}</div>
          </div>
          <span class="infoText">{{ item.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      infoData: [
        {
          icon: "/static/newHomeImg/agent/img_1.png",
          title: "蓝海市场 抢占先机",
          text:
            "面向全国食安数字化管理市场，多项创新产品行业领先，提前进入食安行业数字化时代",
        },
        {
          icon: "/static/newHomeImg/agent/img_2.png",
          title: "产品领先 竞争力强",
          text:
            "紧跟市场需求和技术前沿持续研发投入， 确保市场竞争力",
        },
        {
          icon: "/static/newHomeImg/agent/img_3.png",
          title: "统一营销 共享商机",
          text:
            "浙江安宣集中全国优势宣传资源、渠道资源、合理分配商机信息到区域运营商",
        },
        {
          icon: "/static/newHomeImg/agent/img_4.png",
          title: "分工协作 持续收益",
          text:
            "浙江安宣负责产品研发生产和线上服务，运营商负责区域运营和技术支持，共同服务，共享收益",
        },
      ],
    };
  },
};
</script>

<style scoped>
.box {
  width: 100%;
  height: 716px;
  min-width: 1200px;
  background-repeat: no-repeat;
  background-size: 100% 716px;
  background-image: url("/static/newHomeImg/agent/img_bg_Regionalagency.png");
  padding: 70px 0 0 0;
  box-sizing: border-box;
}
.title {
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  margin-bottom: 30px;
}
.text {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  text-align: center;
}

.bottomItem {
  margin: 64px auto;
  width: 1200px;
  height: 412px;
  display: flex;
}

.bottomItem .leftItem {
  width: 332px;
  height: 412px;

  border-radius: 10px;

  background-image: url("/static/newHomeImg/agent/img_WhychooseZhejianganxuan.png");
}

.rightItem {
  display: flex;
  width: 868px;
  flex-wrap: wrap;
}

.itemBox {
  width: 414px;
  height: 196px;
  margin-left: 20px;
  background: #ffffff;
  border-radius: 10px;
  padding: 49px 49px 62px 49px;
  box-sizing: border-box;
}
.itemBox .header {
  display: flex;
}

.itemBox .header .text {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #141414;
  line-height: 30px;
}
.itemBox .header .img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  margin-bottom: 19px;
}
.infoText {
  display: inline-block;
  width: 313px;
  height: 41px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #555555;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/page/newHomePage/agent.vue